import { mqttUrl, getDeviceId, getSessionTopics } from '../../../config/base'
import { MQTT_GROUP_ID, MQTT_TOPIC } from '../../../config/base'

const Paho = require('paho-mqtt')

let client = null

const mqtt = store => {
  let options = () => ({
    userName: store.state.mqtt.username,
    password: store.state.mqtt.password,
    timeout: 10,
    mqttVersion: 4,
    useSSL: true,
    cleanSession: true,
    onSuccess: () => {
      console.log('MQTT connected')
      store.state.mqttTopics.forEach(topic => {
        store.commit('MQTT_SUBSCRIBE', topic)
      })
    },
    onFailure: (error) => {
      console.log('MQTT failed', error)
      store.commit('MQTT_FAILED')
    }
  })

  let onMessageArrived = (message) => {
    // console.log('MQTT received message', message)
    store.commit('pushMqttMessage', message)
  }
  let onConnectionLost = (error) => {
    console.log('MQTT connection lost', error)
    if (error.errorCode !== 0) {
      setTimeout(() => {
        store.commit('MQTT_CONNECT')
      }, 2000)
    }
  }

  store.commit('assignValue', {
    // 初始化设备ID
    deviceId: getDeviceId(),
    // 刷新页面后能够恢复之前的订阅状态
    topics: getSessionTopics()
  })

  store.subscribe(mutation => {
    switch (mutation.type) {
      case 'MQTT_CONNECT': {
        if (client && client.isConnected()) {
          return
        }
        client = new Paho.Client(mqttUrl, 443, '/', [MQTT_GROUP_ID, store.state.deviceId].join('@@@'))
        client.onMessageArrived = onMessageArrived
        client.onConnectionLost = onConnectionLost
        client.connect(options())
        break
      }
      case 'MQTT_DISCONNECT': {
        if (!client || !client.isConnected()) {
          return
        }
        console.log('MQTT_DISCONNECT')
        client.disconnect()
        break
      }
      case 'MQTT_SUBSCRIBE': {
        if (!client || !client.isConnected()) {
          return
        }
        console.log('MQTT_SUBSCRIBE', mutation.payload)
        client.subscribe(MQTT_TOPIC + mutation.payload, {
          qos: 0,
          onFailure: () => store.commit('MQTT_SUBSCRIBE', {
            topic: mutation.payload
          })
        })
        break
      }
      case 'MQTT_UNSUBSCRIBE': {
        if (!client || !client.isConnected()) {
          return
        }
        console.log('MQTT_UNSUBSCRIBE', mutation.payload)
        client.unsubscribe(MQTT_TOPIC + mutation.payload, true)
        break
      }
      case 'MQTT_SEND': {
        if (!client || !client.isConnected()) {
          return
        }
        console.log('MQTT_SEND', mutation.payload)
        const message = new Paho.Message(JSON.stringify(mutation.payload.message))
        message.destinationName = MQTT_TOPIC + mutation.payload.topic
        message.qos = 0
        message.retained = false
        client.send(...message)
        break
      }
    }
  })
}

export default mqtt